import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import SaisonAuswahl from './pages/SaisonAuswahl';
import HallOfFame from './pages/HallOfFame';
import TippspielPage from './pages/TippspielPage';
import Einstellungen from './pages/Einstellungen';
import AdminPanel from './pages/AdminPanel';
import Board from './pages/Board';
import RankingPage from './pages/RankingPage';
import BonusFragen from './pages/BonusFragen';
import { setupForegroundNotifications } from './utils/notifications';
import { useEffect } from 'react';
import { DarkModeProvider } from './contexts/DarkModeContext';
import NFLBackground from './components/NFLBackground';
import AppLayout from './components/AppLayout';
import './styles/ui.css';
import FAQ from './pages/FAQ';
import Einladung from './pages/Einladung';

// Nur für angemeldete Nutzer – sonst zurück zum Login.
function NurAngemeldet({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation();
  if (!currentUser) {
    return <Navigate to="/" replace state={{ von: location.pathname }} />;
  }
  return children;
}

// Nur für Admins – Spieler landen auf der Saisonauswahl.
function NurAdmin({ children }) {
  const { userProfile } = useAuth();
  if (userProfile?.isAdmin !== true) {
    return <Navigate to="/saison-auswahl" replace />;
  }
  return children;
}

function App() {
  useEffect(() => {
    // Setup Foreground Notifications
    if ('Notification' in window) {
      setupForegroundNotifications();
    }
  }, []);

  return (
      <AuthProvider>
        <DarkModeProvider>
          <NFLBackground>
            <BrowserRouter>
              <Routes>
                {/* Ohne Login erreichbar */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/register" element={<LoginPage />} />
                <Route path="/einladung" element={<Einladung />} />

                {/* Spieler-Bereich im gemeinsamen Rahmen */}
                <Route element={<NurAngemeldet><AppLayout /></NurAngemeldet>}>
                  <Route path="/saison-auswahl" element={<SaisonAuswahl />} />
                  <Route path="/hall-of-fame" element={<HallOfFame />} />
                  <Route path="/tippspiel/:saisonId" element={<TippspielPage />} />
                  <Route path="/saison/:saisonId" element={<TippspielPage />} />
                  <Route path="/saison/:saisonId/ranking" element={<RankingPage />} />
                  <Route path="/saison/:saisonId/bonusfragen" element={<BonusFragen />} />
                  <Route path="/tippspiel/:saisonId/bonusfragen" element={<BonusFragen />} />
                  <Route path="/tippspiel" element={<Navigate to="/saison-auswahl" replace />} />
                  <Route path="/einstellungen" element={<Einstellungen />} />
                  <Route path="/board" element={<Board />} />
                  <Route path="/faq" element={<FAQ />} />
                </Route>

                {/* Admin-Bereich mit eigener Kopfzeile */}
                <Route element={<NurAngemeldet><NurAdmin><AppLayout variante="admin" /></NurAdmin></NurAngemeldet>}>
                  <Route path="/admin" element={<AdminPanel />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </NFLBackground>
        </DarkModeProvider>
      </AuthProvider>
  );
}

export default App;
